const MANIFEST_URL = 'https://videos.narcity.com/manifest.json';
const SANDBOX_MANIFEST_URL = 'https://videos.narcity.com/sandbox/manifest.json';
const IMA_SDK_URL = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';

const DESKTOP_WIDTH = 300;
const DESKTOP_HEIGHT = 500;
const MOBILE_MAX_HEIGHT = '60vh';

const FLOATING_WIDTH = 180;
const FLOATING_HEIGHT = 300;

const AD_REQUEST_TIMEOUT = 5000;
// MRC video viewability: at least half the player in view for 2 continuous
// seconds of ad playback.
const AD_VIEWABLE_MIN_RATIO = 0.5;
const AD_VIEWABLE_MS = 2000;
const PROGRESS_UPDATE_INTERVAL = 250;
const ANALYTICS_ENDPOINT_PATH = '/api/portal/videos/analytics/events';
const ANALYTICS_FLUSH_INTERVAL = 15000;
const ANALYTICS_HEARTBEAT_INTERVAL = 20000;
const ANALYTICS_MAX_BATCH_SIZE = 100;
const ANALYTICS_INACTIVITY_TIMEOUT = 120000;
const ANALYTICS_RETRY_BASE_MS = 1500;
const ANALYTICS_RETRY_MAX_MS = 60000;
const ANALYTICS_MAX_RETRY_ATTEMPTS = 6;

const STORIES_PLAYER_STYLE_ID = 'milla-stories-player-styles';

const DEFAULT_VAST_PRE_ROLL_TAG =
  'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dlinear&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&vpmute=1&vpa=auto&impl=s&correlator=';

const DEFAULT_VAST_INTERSTITIAL_TAG = DEFAULT_VAST_PRE_ROLL_TAG;

module.exports = {
  MANIFEST_URL,
  SANDBOX_MANIFEST_URL,
  IMA_SDK_URL,
  DESKTOP_WIDTH,
  DESKTOP_HEIGHT,
  MOBILE_MAX_HEIGHT,
  FLOATING_WIDTH,
  FLOATING_HEIGHT,
  AD_REQUEST_TIMEOUT,
  AD_VIEWABLE_MIN_RATIO,
  AD_VIEWABLE_MS,
  PROGRESS_UPDATE_INTERVAL,
  ANALYTICS_ENDPOINT_PATH,
  ANALYTICS_FLUSH_INTERVAL,
  ANALYTICS_HEARTBEAT_INTERVAL,
  ANALYTICS_MAX_BATCH_SIZE,
  ANALYTICS_INACTIVITY_TIMEOUT,
  ANALYTICS_RETRY_BASE_MS,
  ANALYTICS_RETRY_MAX_MS,
  ANALYTICS_MAX_RETRY_ATTEMPTS,
  STORIES_PLAYER_STYLE_ID,
  DEFAULT_VAST_PRE_ROLL_TAG,
  DEFAULT_VAST_INTERSTITIAL_TAG
};
